import Common from "~/js/common/common";
import store from "~/js/store/store";
import Header from "~/js/common/header";
import Footer from "~/js/common/footer";
import Password from "./password";
import Tooltip from "~/js/common/tooltip";
import ForgotPasswordModal from "./modal/forgotPasswordModal";

export default class Login {
  constructor() {
    store.subscribe((mutation, state) => {
      if (mutation.type === "beforeScroll") {
      } else if (mutation.type === "init") {
        this.init();
      }
    });

    this.header = new Header();
    this.footer = new Footer();
    this.tooltip = new Tooltip();
    this.passwords = [];
    const _password = document.querySelectorAll(".f-password");
    for (var i = 0; i < _password.length; i++) {
      this.passwords.push(new Password(_password[i]));
    }
    this.forgotPasswordModal = new ForgotPasswordModal();

    store.dispatch("init");
  }

  init() {
    window.scrollTo(0, 0);
    Common.init();
    Common.setupScrollY();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new Login();
});
